<div class="flex-row flex-start-start mobile-centered">
  <div class="flex-1">
    <form [formGroup]="notificationsForm" novalidate class="registration-form">
      <div class="mat-headline-3 registration-title">Notification Preferences</div>
      <h4 class="registration-description">Select how you would like to receive notifications. If you wish to change your notification email, the email you
        use to login will not change.</h4>
      <div class="flex-col flex-gap-20">
        <rv-input-form-field fieldName="notificationEmail" [externalLabel]="true" overrideLabel="Notification Email" [formGroup]="notificationsForm"/>
        <rv-phone-form-field fieldName="mobilePhone" [externalLabel]="true" overrideLabel="Mobile Phone Number" [formGroup]="notificationsForm"/>
        <div>
          <h4 class="form-label">I prefer to be contacted by:</h4>
          <rv-radio-group-form-field fieldName="notifyMethod" [options]="NOTIFICATION_OPTIONS" [formGroup]="notificationsForm"/>
        </div>
        <rv-checkbox-form-field fieldName="smsTermsAccepted" [formGroup]="notificationsForm" overrideLabel="">
          I agree to receive automated SMS/text notifications from my library related to my library account and circulation activity. Message frequency varies.
          Message and data rates may apply. I can manage notification preferences in my account or contact library staff for help. See
          <a href="https://www.simplicity-ils.com/sms-notification-terms" target="_blank" rel="noopener">SMS Notification Terms</a> and
          <a href="https://www.simplicity-ils.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.
        </rv-checkbox-form-field>
        <button mat-raised-button color="primary" class="next-button" (click)="onClickNext()" [disabled]="!notificationsForm.valid">Next</button>
      </div>
    </form>
  </div>
  <div class="set-notifications-img flex-1 hide-for-mobile"></div>
</div>
